import { render, staticRenderFns } from "./DialogMobileChat.vue?vue&type=template&id=00c0f16f"
import script from "./DialogMobileChat.vue?vue&type=script&lang=js"
export * from "./DialogMobileChat.vue?vue&type=script&lang=js"
import style0 from "./DialogMobileChat.vue?vue&type=style&index=0&id=00c0f16f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c0f16f')) {
      api.createRecord('00c0f16f', component.options)
    } else {
      api.reload('00c0f16f', component.options)
    }
    module.hot.accept("./DialogMobileChat.vue?vue&type=template&id=00c0f16f", function () {
      api.rerender('00c0f16f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatGPT3.0/DialogMobileChat.vue"
export default component.exports